<template>
    <button class="btn btn-info" :class="btnClass" :disabled="poster.submitted" @click="posterPost()">
        <span class="spinner-border spinner-border-sm"></span>
        <slot></slot>
    </button>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        employee: {
            required: true
        },
        btnClass: {
            default: ''
        }
    },

    computed: {
        posterUrl () {
            return '/employees/' + this.employee.id + '/disableAccount'
        }
    },

    methods: {
        posterSuccess (data) {
            if (this.employee.disabled_at) {
                bus.$emit(
                    'notify',
                    'Kontot har återaktiverats'
                )
            } else {
                bus.$emit(
                    'notify',
                    'Kontot har inaktiverats'
                )
            }
            this.$emit('refresh')
        }
    }
}
</script>
